import { Control, FieldPath, FieldValues, useController } from 'react-hook-form';
import { Textarea } from '@givebutter/primitives/textarea';
import { FormField } from './FormField';

interface FormTextareaProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  label?: string;
  description?: string;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
}

export const FormTextarea = <T extends FieldValues>({
  name,
  control,
  label,
  description,
  placeholder,
  disabled,
  rows = 3,
}: FormTextareaProps<T>) => {
  const {
    field: { value, onChange, onBlur, ref },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <FormField label={label} htmlFor={name} description={description} error={error?.message}>
      <Textarea
        id={name}
        ref={ref}
        value={value ?? ''}
        onChange={e => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
      />
    </FormField>
  );
};
